import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { filter, tap, combineLatest, distinctUntilChanged } from 'rxjs/operators';
import { AthleteCategoriesCombo } from '../../../common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "../../services/filters-athlete-general.service";
import * as i2 from "@angular/common/http";
export class FiltersAthleteWorldRankingsStatisticsService {
    constructor(common_service, http) {
        this.common_service = common_service;
        this.http = http;
        /**
         * The common categories combo without team value.
         *
         * @type {AthleteCategoriesCombo}
         * @memberof FiltersAthleteWorldRankingsStatisticsService
         */
        this.categoryComboStats = new AthleteCategoriesCombo('Categories: ', 'stats-combo', [], this.http, false);
        this.common_service.storedId.pipe(filter(a => a != null), combineLatest(this.common_service.athleteDetailStore.dataStream.pipe(filter(value => value != null), distinctUntilChanged((f, s) => f[0].Id === s[0].Id))), tap(([a, b]) => {
            const worldRankingData = (b[0].WorldRankings.Best).sort((f, s) => f.Rnk > s.Rnk ? 1 : -1);
            const comboData = b[0].AthleteCategories
                .filter(value => worldRankingData.findIndex(worldRankingCategory => value.Cat === worldRankingCategory.CatCode) > -1)
                .map((value, i) => { return { item: value, position: i }; });
            this.categoryComboStats = new AthleteCategoriesCombo('Categories: ', 'stats-combo', comboData, http, false);
            // Select current if any, if not, the better from historic data.
            const worldRankingBestData = (b[0].WorldRankings.Current && b[0].WorldRankings.Current.length > 0 ?
                b[0].WorldRankings.Current :
                b[0].WorldRankings.Best).sort((f, s) => f.Rnk > s.Rnk ? 1 : -1);
            const categorySelected = comboData.find(value => value.item.Cat === worldRankingBestData[0].CatCode);
            // Se the default category with highest world ranking rank.
            setTimeout(() => {
                this.categoryComboStats.filterInfo.options.options_selected_subject.next(categorySelected.item);
            }, 30);
        })).subscribe();
    }
}
FiltersAthleteWorldRankingsStatisticsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FiltersAthleteWorldRankingsStatisticsService_Factory() { return new FiltersAthleteWorldRankingsStatisticsService(i0.ɵɵinject(i1.FiltersAthleteGeneralService), i0.ɵɵinject(i2.HttpClient)); }, token: FiltersAthleteWorldRankingsStatisticsService, providedIn: "root" });
